import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import api from '../../services/api';
import { useSession } from '../../providers/SessionProvider';

import ContentHeader from '../../components/ContentHeader';
import Footer from '../../components/Footer';
import MainHeader from '../../components/MainHeader';
import SideMenu from '../../components/SideMenu';
import MyLoadingOverlay from '../../components/MyLoadingOverlay';

function FAQ() {
  const {
    setIsAssessoryMenuSelected,
    _token,
    isLoading,
    setIsLoading,
  } = useSession();
  const [categories, setCategories] = useState([]);
  const [faqs, setFaqs] = useState([]);

  const loadFaqs = async categoryId => {
    const config = {
      headers: { Authorization: `Bearer ${_token}` },
    };

    setIsLoading(true);

    await api
      .get(`api/faqs?category_id=${categoryId}`, config)
      .then(response => {
        const { data } = response.data;

        setFaqs(data);
        setIsLoading(false);
      });
  };

  const handleCategoryLink = (e, categoryId) => {
    e.preventDefault();
    loadFaqs(categoryId);
  };

  const loadCategories = async () => {
    const config = {
      headers: { Authorization: `Bearer ${_token}` },
    };

    setIsLoading(true);

    await api.get(`api/categories?type=0`, config).then(response => {
      const { data } = response.data;
      const { id } = data[0];

      setCategories(data);
      setIsLoading(false);
      loadFaqs(id);
    });
  };

  useEffect(() => {
    setIsAssessoryMenuSelected(true);
    loadCategories();
  }, []);

  return (
    <div className="interna gray">
      <div className="white" />
      <div className="container bug-height">
        <div className="row first-row">
          <div className="col grid_3 left-menu">
            <MainHeader />
            <SideMenu />
          </div>
          <div className="col grid_9 content">
            <ContentHeader />
            <h3>Assessoria Jurídica - Dúvidas Frequentes:</h3>
            <div className="faq row gutters">
              <div className="col grid_4 categorias">
                <h5>Categorias:</h5>
                <ul>
                  {categories.map(category => (
                    <li key={category.name}>
                      <a
                        onClick={e => handleCategoryLink(e, category.id)}
                        href="/"
                      >
                        {category.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <ul className="col grid_8 perguntas">
                {faqs.map(faq => (
                  <li key={String(faq.id)}>
                    <label htmlFor={`item-${faq.id}`}>
                      <input name="ask" id={`item-${faq.id}`} type="checkbox" />
                      <h6>{faq.title}</h6>
                      <div className="question">
                        <p>{faq.content}</p>
                      </div>
                    </label>
                  </li>
                ))}
              </ul>
              <div className="contact-duvidas">
                <h5>
                  Não encontrou sua dúvida?
                  <Link to="/faq/send">Entre em contato conosco</Link>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      {isLoading && <MyLoadingOverlay />}
    </div>
  );
}

export default FAQ;
